import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => {
  return {
    page: css`
      width: 100%;
      height: 100dvh;
      overflow-y: hidden;
    `,
    body: css`
      position: absolute;
      top: 50%;
      svg {
        width: 48px;
        height: 48px;
        border-radius: 100%;
        background: var(--Global-token-Bg-colorBgBase, #fff);
        padding: var(--Global-token-Padding-paddingSM, 12px);
        cursor: pointer;
      }
    `,
  };
});
export default useStyles;
